import angular from 'angular';
import commissionManagement from './commissionManagement';
import scenes from './scenes';
import services from './services';

export default angular
  .module('commission.scenes.commissionManagement', [scenes, services])
  .component('commissionManagement', commissionManagement).name;
